export const revenueCatAppUserId = (user) => {
    if (user?.id === undefined || user?.id === null) {
        return null
    }

    const appUserID = String(user.id).trim()

    return appUserID || null
}

/**
 * shouldContinue lets the caller abort between native calls. Without it a load
 * started for account A keeps calling logIn/setEmail on the SDK after account B
 * has become the signed-in user, leaving RevenueCat identified as the wrong one.
 */
export const identifyRevenueCatUser = async ({ purchases, user, apiKey, shouldContinue = () => true }) => {
    const appUserID = revenueCatAppUserId(user)
    if (!apiKey || !appUserID) {
        return false
    }

    const { isConfigured } = await purchases.isConfigured()
    if (!shouldContinue()) {
        return false
    }

    if (!isConfigured) {
        await purchases.configure({ apiKey, appUserID })
    } else {
        const { appUserID: currentAppUserID } = await purchases.getAppUserID()
        if (!shouldContinue()) {
            return false
        }
        if (currentAppUserID !== appUserID) {
            await purchases.logIn({ appUserID })
        }
    }

    if (!shouldContinue()) {
        return false
    }

    // Metadata is best-effort: the account is already identified above, and a
    // failing setEmail/setDisplayName must never prevent the offerings from
    // loading — that would hide the paywall over a cosmetic attribute.
    const displayName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || null
    try {
        await purchases.setEmail({ email: user?.email || null })
    } catch (error) {
        console.warn('#PURCHASES setEmail failed', error)
    }
    try {
        await purchases.setDisplayName({ displayName })
    } catch (error) {
        console.warn('#PURCHASES setDisplayName failed', error)
    }

    return true
}
